module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxlbGxpcHNlIGN4PSI0LjYwMTAyIiBjeT0iNC41IiByeD0iNC42MDEwMiIgcnk9IjQuNSIgZmlsbD0iIzRGQTQ2MiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/status-green.svg
// module id = Y3WA
// module chunks = 0